import React from "react";

type Feature = { name: string; pct: number };
const LegendItem = ({
  color,
  label,
  pct,
}: {
  color: string;
  label: string;
  pct: number;
}) => (
  <div className="relative group flex items-center">
    <span
      className="h-[10px] w-[10px] rounded-full mr-2"
      style={{ background: color }}
    />
    {/* Keep it truncated in-row */}
    <span
      className="text-[#141414] truncate max-w-[150px] cursor-default"
      title={label}
      aria-label={label}
    >
      {label}
    </span>
    <span className="text-[#777B7F] ml-2 tabular-nums">{Math.round(pct)}%</span>

    {/* <div className="pointer-events-none absolute left-0 top-full z-20 mt-2 hidden w-max max-w-[260px] rounded-md bg-black/90 px-2 py-1 text-[11px] leading-snug text-white shadow-lg group-hover:block">
      {label}
    </div> */}
  </div>
);

export default function TotalGrantsByFeaturesCard({
  title = "Total Grants by Features",
  totalLabel = "Total Grants",
  total = 0,
  features = [],
}: {
  title?: string;
  totalLabel?: string;
  total: number;
  features: Feature[];
}) {
  // pick top 15 by pct for a clean legend
  const top = [...features].sort((a, b) => b.pct - a.pct).slice(0, 15);
  const palette = [
    "#F59E0B", "#60A5FA", "#EF4444", "#22C55E", "#10B981",
    "#8B5CF6", "#E879F9", "#3B82F6", "#8b4848ff", "#F472B6",
    "#FBBF24", "#34D399", "#A78BFA", "#442334ff", "#503d87ff",
  ];

  // build conic-gradient
  const sum = top.reduce((s, f) => s + (f.pct || 0), 0) || 1;
  const gapDeg = 1.2;
  let acc = 0;
  const stops: string[] = [];
  top.forEach((f, i) => {
    const start = (acc / sum) * 360;
    const end = ((acc + f.pct) / sum) * 360;
    const color = palette[i % palette.length];
    const safeEnd = end - gapDeg;
    stops.push(`${color} ${start}deg ${Math.max(start, safeEnd)}deg`);
    stops.push(`#FFFFFF ${Math.max(start, safeEnd)}deg ${end}deg`);
    acc += f.pct;
  });

  return (
    <div className="rounded-2xl border border-[#E5E7EB] bg-white shadow-[0_1px_2px_rgba(16,24,40,0.04)]">
      <div className="p-5 md:p-5">
        <div className="text-[15px] font-semibold text-[#111] mb-3">{title}</div>

        <div className="flex flex-col items-center gap-6">
          {/* Donut */}
          <div
            className="relative h-[136px] w-[136px] rounded-full"
            style={{ background: `conic-gradient(${stops.join(",")})` }}
            aria-label="Donut chart"
          >
            {/* ring thickness */}
            <div className="absolute inset-4 rounded-full bg-white grid place-items-center text-center px-2">
              <div className="text-[11px] text-[#6B7280] leading-none">{totalLabel}</div>
              <div className="text-[18px] font-semibold text-[#141414] leading-tight">{total}</div>
            </div>
          </div>

          {/* Legend */}
          <div className="grid grid-cols-2 gap-[10px] text-[12px] overflow-visible">
            {top.map((f, i) => (
              <LegendItem
                key={i}
                color={palette[i % palette.length]}
                label={f.name}
                pct={f.pct}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
